import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Returns to the top on every route change. */
export const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
